module.exports = __webpack_public_path__ + "media/images/emblems/Serravalle_stemma-dc69d276e489f84058321a3aed05a1c8.png";